// extracted by mini-css-extract-plugin
export var bgImage = "Section-module--bgImage--a2394";
export var container = "Section-module--container--12654";